import { enforce, omitWhen, test } from 'vest';

import {
  isEndpointUrl,
  isTimeZone,
  withDefaults,
} from 'admin-panel/utils/integrations/config';

import type { IntegrationConfig } from 'admin-panel/models/integrations/configuration';
import type {
  IntegrationFormValues,
  ServiceFormDefinition,
} from 'admin-panel/utils/integrations/types';

export interface StayntouchService {
  authEndpointUrl: string;
  apiEndpointUrl: string;
  clientId: string;
  clientSecret: string;
  hotelId: number | null;
  timezone: string;
}

const SERVICE = 'currentConfig.service';

const defaultConfig = (): IntegrationConfig => ({
  service: {
    authEndpointUrl: 'https://auth.stayntouch.com',
    apiEndpointUrl: 'https://api.stayntouch.com/connect',
    clientId: '',
    clientSecret: '',
    hotelId: null,
    timezone: '',
  },
  features: {},
  cron: [],
  webhooks: [],
});

export const stayntouch: ServiceFormDefinition = {
  toFormConfig: (config) => withDefaults(defaultConfig(), config),

  validate(values: IntegrationFormValues, t) {
    const service = values.currentConfig
      .service as unknown as StayntouchService;

    for (const field of ['authEndpointUrl', 'apiEndpointUrl'] as const) {
      test(`${SERVICE}.${field}`, t('validations.required'), () => {
        enforce(service[field]).isNotBlank();
      });

      omitWhen(!service[field], () => {
        test(`${SERVICE}.${field}`, t('validations.url'), () => {
          enforce(isEndpointUrl(service[field])).isTruthy();
        });
      });
    }

    for (const field of ['clientId', 'clientSecret'] as const) {
      test(`${SERVICE}.${field}`, t('validations.required'), () => {
        enforce(service[field]).isNotBlank();
      });
    }

    test(`${SERVICE}.hotelId`, t('validations.required'), () => {
      enforce(Number.isInteger(Number(service.hotelId))).isTruthy();
      enforce(String(service.hotelId ?? '')).isNotBlank();
    });

    test(`${SERVICE}.timezone`, t('validations.required'), () => {
      enforce(service.timezone).isNotBlank();
    });

    omitWhen(!service.timezone, () => {
      test(`${SERVICE}.timezone`, t('validations.invalid'), () => {
        enforce(isTimeZone(service.timezone)).isTruthy();
      });
    });
  },
};
